import styled from 'styled-components';

export const ShowOriginalResumeLink = styled.div`
  font-family: 'Neutraface2TextDemi';
  font-size: 18px;
  margin: 10px 0;
`;
